import { useState, useRef, useEffect} from 'react'

import { Player } from '@lottiefiles/react-lottie-player'

import styles from './video.module.sass'

import BlockWrapper from '../layout/block_wrapper'

import classNames from 'classnames'

import get from 'lodash/get'

function Lottie(props) {
    const player = useRef(null)
	let fields = get(props, 'fields.lottie', props) || null
	let settings = props.settings || null
	let classes = props.className
	let settingsProps = null
    let autoplay = settings?.autoplay != undefined ? settings.autoplay : true
    let loop = settings?.loop != undefined ? settings.loop : true
    let [lottie, setLottie] = useState(null)

    useEffect(() => {
        if (player.current) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && autoplay) {
                        lottie?.goToAndPlay(0)
                    } else {
                        lottie?.pause()
                    }
                });
            }, { threshold: 0.5 })

            observer.observe(player.current.container)
            
            return () => observer.disconnect()
        }
    }, [player.current, lottie, props])


	if(props.layout_settings){
        return <BlockWrapper {...props} className={classNames(styles.video, classes)}>
            <Player
                lottieRef={(data) => {
                    setLottie(data)
                }}
                ref={player}
                autoplay={false}
                loop={loop}
                controls={false}
                style={{width: '100%', height: '100%'}}
                src={fields.url}
            />
        </BlockWrapper>
    } else {
        return <div className={classNames(styles.lottie, classes)}>
            <Player
                lottieRef={(data) => {
                    setLottie(data)
                }}
                ref={player}
                autoplay={false}
                loop={loop}
                controls={false}
                style={{width: '100%', height: '100%'}}
                src={fields.url}
            />
        </div>
    }
}

export default Lottie